{
  "EMOJI": {
    "PLACEHOLDER": "ابحث في الايموجي",
    "NOT_FOUND": "لا يوجد إيموجي يطابق بحثك",
    "REMOVE": "حذف"
  }
}
